export const PIN_COLOR = "#00295E";

export const TYPE_COLORS = Object.freeze({
  artist: "#6AD3F9",
  store: "#40DED9",
  shop: "#40DED9",
  manufacturer: "#C3BBFA",
  museum: "#E299FF",
  studio: "#FF80D9",
  iac: "#DEDBDB",
  institution: "#41E59B",
  gallery: "#FF7D8E",
  residency: "#FFC2AC",
  organization: "#C3E6FF",
  organisation: "#C3E6FF",
  chs: "#FFDE61",
  "cultural heritage site": "#FFDE61",
});

export const DEFAULT_TYPE_COLOR = TYPE_COLORS.iac;

export const normalizeType = (type) =>
  String(type ?? "")
    .trim()
    .toLowerCase();

export const getTypeColor = (type) =>
  TYPE_COLORS[normalizeType(type)] ?? DEFAULT_TYPE_COLOR;
